import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureConfigActions from "../../../store/actions/FeatureConfig";
import * as FeatureActions from "../../../store/actions/Feature";
import * as CountryActions from "../../../store/actions/Country";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import { getPath } from "../../../utils";
import * as UserActions from "../../../store/actions/User";
import * as DriverServicesActions from "../../../store/actions/DriverServices";
import { FlexContainer } from "../../../constants/assets/containers";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import styled from "styled-components";
import { isValNull } from "../../../utils";
import { convertValueByDataType, filterObj, isFloat } from "../../../utils";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import variables from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal, Link } from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import _ from "lodash-es";
import DateTimePicker from "../../Common/DateTimePicker";
import * as Operators from "../../../constants/FeatureConfig/Operator";
import Cross from "sushiweb/Icons/all/Cross";
import ErrorMsgs from "../../../constants/Errors.json";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";
import { useHistory } from "react-router-dom";
import beautify from "js-beautify";
import {
  PEAK_TIME_PAYLOAD_PARAM,
  POST_UPDATE_SUB_TYPE_LABELS,
  PRE_UPDATE_SUB_TYPE_LABELS,
  REPEAT_OPTIONS,
  RULE_SUB_TYPES,
} from "../../../constants/FeatureConfig/constants";
import Checkbox from "sushiweb/InputTypes/Checkbox";

export const entityOptions = [
  { key: "User", label: "User" },
  { key: "Locality", label: "Locality" },
  { key: "City", label: "City" },
  { key: "Country", label: "Country" },
  { key: "", label: "Global" },
];

const boolValueOptions = [
  { key: "true", label: "True" },
  { key: "false", label: "False" },
];

const DataTypeOptions = [
  {
    key: "float64",
    label: "Number",
  },
  {
    key: "string",
    label: "String",
  },
  {
    key: "json",
    label: "JSON (array & object)",
  },
  {
    key: "bool",
    label: "Bool",
  },
  {
    key: "time",
    label: "Time",
  },
];

const disabledFieldsInEditState = ["entityId", "entity", "activeCityId"];

const conditionTypeOptions = [
  { key: "service_id", label: "Delivery Services" },
  { key: "app_version", label: "App Version" },
  { key: "source_id", label: "Source ID" },
  { key: "timestamp", label: "Timestamp" },
  { key: "custom", label: "Custom Condition" },
];

const comparatorOptions = [
  { key: Operators.GT, label: "Greater than" },
  { key: Operators.LT, label: "Less than" },
  { key: Operators.EQ, label: "Equals to" },
  { key: Operators.NOT_EQ, label: "Not equals to" },
  { key: Operators.GTE, label: "Greater than and equals to" },
  { key: Operators.LTE, label: "Less than and equals to" },
  { key: Operators.IN, label: "In" },
];

const ruleTypeOptions = [
  { key: "pre-update", label: "Prior to config create/update)" },
  { key: "post-update", label: "Post config create/update" },
];

const notificationOptions = [{ key: "slack", label: "Slack" }];

const ruleSubTypeOptions = [
  { key: "notification", label: "Notification" },
  { key: "validation", label: "Schema Validation" },
  { key: "peak-time", label: "Peak Time" },
];

const UpsertActionTypes = {
  Create: 1,
  Edit: 0,
};

export const FeatureConfigFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeHierarchyFiltersConfig,
    getCountryList,
    getLocalityList,
    getCityList,
    nextPageCity,
    nextPageCountry,
    getCountry,
    getCity,
    getDriverServices,
    getDriverServiceByIds,
    setCurrentPage,
    handlePagination,
    selectedKey,
    selectedNamespace,
    selectedEntity = "",
    selectedEntityId = "",
    selectedCityId = "",
    updateChangeLog,
    stable = false,
  } = props;
  const [dropDownModalState, setDropDownModalState] = useState(modalState);
  const [priorityFlag, setPriorityFlag] = useState(0);
  const [isValidJson, setIsValidJson] = useState(true);
  const [isValidJsonSchema, setIsValidJsonSchema] = useState(true);
  const history = useHistory();
  const [initialState, setInitialState] = useState({
    entityId: selectedEntityId,
    entity: selectedEntity,
    activeCityId: selectedCityId,
    dataType: "",
    value: "",
    updatedAt: "",
    id: "",
    serviceId: [],
    variantsList: [],
    rulesList: [],
    key: "",
    actionsRequired: {},
    namespaceActions: {},
    stable: stable
  });

  const isJson = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  const applyFilter = () => {
    let queryString = `namespace=${selectedNamespace}`;
    queryString += `&key=${selectedKey}`;
    queryString += `&entity=${getPath(initialState, "entity", "")}`;
    queryString += `&entityId=${getPath(initialState, "entityId", "")}`;
    queryString += `&cityId=${getPath(initialState, "activeCityId", "")}`;
    const targetRoute = `/feature-config/list?${queryString}`;
    history.push(targetRoute);
  };

  const handleSubmit = async () => {
    const hierarchyFilters = filterObj(initialState, ["entityId", "entity"]);
    const driverService = await getDriverServices();

    const getNameById = (targetId) => (driverService.driver_services.find(service => service.id === targetId)?.name) || "";
      
    if (modalState === "Filter") {
      const page = 1;
      const payload = {
        filters: {
          key: selectedKey,
          hierarchy: hierarchyFilters,
        },
        namespace: selectedNamespace,
        pagination: {
          limit: 20,
        },
        page,
      };
      props.filterKeyConfigs(payload).then((res) => {
        handlePagination(page, { pageToken: res.pagination?.pageToken });
        handlePagination(page, { pageToken: res.pagination?.nextPageToken });
        setCurrentPage(page);
        handleClose();
      });
    } else {
      if (!initialState.key) {
        props.setStatus({ type: "error", message: "key is required" });
        return;
      }
      if (!initialState.dataType) {
        props.setStatus({ type: "error", message: "data type is required" });
        return;
      }
      const variantWithNoCondition = getPath(
        initialState,
        "variantsList",
        []
      ).findIndex((variant) => getPath(variant, "conditions", []).length == 0);
      if (variantWithNoCondition >= 0) {
        props.setStatus({
          type: "error",
          message:
            "please add conditions for variant " +
            String(variantWithNoCondition + 1),
        });
        return;
      }
      const variantsList = initialState.variantsList.map((variant) => {
        let val, conditions;
        try {
          typeof variant.value == "object"
            ? (val = JSON.stringify(variant.value))
            : (val = variant.value);
          val = convertValueByDataType(initialState.dataType, val);
          conditions = variant.conditions.map((condition) => {
            if (condition.op == "in") {
              try {
                condition.rhs =
                  typeof condition.rhs == "string"
                    ? JSON.parse(condition.rhs)
                    : condition.rhs;
              } catch (e) {
                props.setStatus({
                  type: "error",
                  message: "invalid json condition value",
                });
                return;
              }
            } else if (condition.lhs == "timestamp") {
              try {
                condition.rhs = parseInt(condition.rhs);
              } catch (e) {
                props.setStatus({
                  type: "error",
                  message: "invalid timestamp value",
                });
                return;
              }
            }

            if(isFloat(condition.rhs)){
              condition.rhs = parseFloat(condition.rhs);
            }

            if(condition.lhs == "service_id"){
              const cond = {
                lhs: condition.lhs,
                op: condition.op,
                rhs: condition.rhs,
              }

              const arr = [] ; 
              condition.rhs.forEach((entry) => {
                if(typeof entry === 'number'){
                  const serviceName = getNameById(entry) ;
                  arr.push(entry) ; 
                  arr.push(serviceName) ; 
                }
              })

              cond.rhs = arr ; 
              return cond ; 
            }

            if (condition.lhs == "custom") {
              return {
                lhs: condition.customCondition,
                rhs: condition.rhs,
                op: condition.op,
              };
            }
            return {
              lhs: condition.lhs,
              op: condition.op,
              rhs: condition.rhs,
            };
          });
        } catch (error) {
          props.setStatus({ type: "error", message: "invalid json value" });
          return;
        }
        return {
          ...variant,
          conditions: conditions,
          value: val,
        };
      });

      let val;
      try {
        val = convertValueByDataType(initialState.dataType, initialState.value);
      } catch (error) {
        props.setStatus({ type: "error", message: "invalid json value" });
        return;
      }

      const action =
        modalState == "Add" ? UpsertActionTypes.Create : UpsertActionTypes.Edit;
      let readActionsRequired = getPath(
        initialState,
        "actionsRequired.read",
        []
      );
      let writeActionsRequired = getPath(
        initialState,
        "actionsRequired.write",
        []
      );

      let namespaceReadActions = getPath(
        initialState,
        "namespaceActions.read",
        []
      );

      let namespaceWriteActions = getPath(
        initialState,
        "namespaceActions.write",
        []
      );

      if (action == UpsertActionTypes.Create || action == UpsertActionTypes.Edit) {
        try {
          const response = await props.getNamespace(selectedNamespace);
          if (response) {
            readActionsRequired.push(
              ...getPath(response, "namespace.configActions.read", [])
            );

            writeActionsRequired.push(
              ...getPath(response, "namespace.configActions.write", [])
            );

            namespaceReadActions.push(
              ...getPath(response, "namespace.namespaceActions.read", [])
            )

            namespaceWriteActions.push(
              ...getPath(response, "namespace.namespaceActions.write", [])
            )

            setInitialState({
              ...initialState,
              actionsRequired: {
                read: readActionsRequired,
                write: writeActionsRequired,
              },
              namespaceActions: {
                read: namespaceReadActions,
                write: namespaceWriteActions,
              }
            });
          }
        } catch (err) {
          props.setStatus({
            type: "error",
            message: String(ErrorMsgs.GENERAL_ERROR_1),
          });
        }
      }
      try {
        const response = await props.upsertConfig({
          namespaceConfigs: [
            {
              namespace: selectedNamespace,
              configs: [
                {
                  key: initialState.key,
                  entity: initialState.entity,
                  entityId: initialState.entityId,
                  value: val,
                  variants: variantsList,
                  rules: initialState.rulesList,
                  actions: getPath(initialState, "actionsList", {}),
                  stable: initialState.stable
                },
              ],
            },
          ],
          actionsRequired: {
            read: readActionsRequired,
            write: writeActionsRequired,
          },
          namespaceActions: {
            read: namespaceReadActions,
            write: namespaceWriteActions,
          },
          action: action,
        });

        if (response) {
          props.setStatus({
            type: "success",
            message: "Successfully Upserted Config",
          });
          if (updateChangeLog !== undefined) {
            updateChangeLog();
          }
          syncFilters();
          handleClose();
        }
      } catch (error) {
        props.setStatus({
          type: "error",
          message: String(error),
        });
      }
    }
  };

  const handleClearFilters = () => {
    if (!selectedKey) {
      props.setStatus({
        type: "error",
        message: "either key or one geo filter is required",
      });
      return;
    }

    let queryString = `namespace=${selectedNamespace}`;
    queryString += `&key=${selectedKey}`;
    const targetRoute = `/feature-config/list?${queryString}`;
    history.push(targetRoute);
  };

  const handleVariantListChange = (key, val, extraPrams) => {
    let values = { ...initialState };
    const variantIndex = extraPrams.length > 0 ? extraPrams[0] : 0;
    const conditionIndex = extraPrams.length > 1 ? extraPrams[1] : 0;
    const variantsList = values.variantsList;
    const variant = variantsList[variantIndex];
    if (key === "lhs") {
      variant.conditions[conditionIndex][key] = val;
      variant.conditions[conditionIndex]["op"] =
        val == "app_version" ? Operators.GTE : Operators.IN;
      variant.conditions[conditionIndex]["rhs"] =
        val == "app_version" || val == "service_id" ? [] : "[]";
    } else if (key === "value") {
      if (!initialState.dataType) {
        props.setStatus({ type: "error", message: "data type is required" });
        return;
      }
      variant.value = val;
    } else if (key == "customCondition") {
      variant.conditions[conditionIndex].customCondition = val;
    } else {
      variant.conditions[conditionIndex][key] = val;
    }

    if (
      key === "op" &&
      variant.conditions[conditionIndex]["lhs"] != "service_id"
    ) {
      variant.conditions[conditionIndex]["rhs"] =
        val == Operators.IN || val == Operators.NOT_IN ? "[]" : "";
    }

    setInitialState({
      ...values,
      variantsList: variantsList,
    });
  };

  const handleDeleteVariant = (variantIndex) => {
    const values = { ...initialState };
    const variantsList = getPath(values, "variantsList", []);
    variantsList.splice(variantIndex, 1);

    setInitialState({
      ...values,
      variantsList: variantsList,
    });
  };

  const handleDeleteCondition = (variantIndex, conditionIndex) => {
    const values = { ...initialState };
    const variantsList = getPath(values, "variantsList", []);
    const conditions = getPath(variantsList[variantIndex], "conditions");
    conditions.splice(conditionIndex, 1);

    setInitialState({
      ...values,
      variantsList: variantsList,
    });
  };

  const handleDeleteRule = (ruleIndex) => {
    const values = { ...initialState };
    const rulesList = getPath(values, "rulesList", []);
    rulesList.splice(ruleIndex, 1);

    setInitialState({
      ...values,
      rulesList: rulesList,
    });
  };

  const handleRuleListChange = (key, val, extraPrams) => {
    let values = { ...initialState };
    const index = extraPrams.length > 0 ? extraPrams[0] : 0;
    if (key == "Source") {
      values.rulesList[index].baseRule["Source"] = val;
    } else if (key == "Schema") {
      if (!values.rulesList[index].baseRule["Meta"]) {
        values.rulesList[index].baseRule["Meta"] = {};
      }
      try {
        JSON.parse(val);
        setIsValidJsonSchema(true);
      } catch (error) {
        setIsValidJsonSchema(false);
      }
      values.rulesList[index].baseRule["Schema"] = val;
    } else if (key === "Channel") {
      if (!values.rulesList[index].baseRule["Meta"]) {
        values.rulesList[index].baseRule["Meta"] = {};
      }
      values.rulesList[index].baseRule["Meta"]["Channel"] = val;
    } else if (PEAK_TIME_PAYLOAD_PARAM.includes(key)) {
      values.rulesList[index].baseRule[key] = val;
    } else {
      values.rulesList[index][key] = val;
    }
    setInitialState(values);
  };

  const handleActionChange = (actionType, val, index) => {
    let values = { ...initialState };
    values.actionsList[actionType][index] = val;
    setInitialState(values);
  };

  const handleAddCondition = (variantIndex) => {
    const values = { ...initialState };
    const variantsList = values.variantsList;
    const variant = variantsList[variantIndex];
    variant.conditions.push({
      lhs: "",
      customCondition: "",
      op: "",
      rhs: "",
    });
    const updatedInitialState = {
      ...values,
      variantsList: variantsList,
    };
    setInitialState(updatedInitialState);
  };

  const handleAddVariant = () => {
    setDropDownModalState("Add");
    const updatedInitialState = {
      ...initialState,
      variantsList: [
        ...initialState.variantsList,
        {
          conditions: [
            {
              lhs: "",
              op: "",
              rhs: "",
            },
          ],
          value: "",
        },
      ],
    };
    setInitialState(updatedInitialState);
  };

  const handleAddRule = () => {
    setDropDownModalState("Add");
    const updatedInitialState = {
      ...initialState,
      rulesList: [
        ...initialState.rulesList,
        {
          type: "",
          subType: "",
          entities: [],
          baseRule: {},
        },
      ],
    };
    setInitialState(updatedInitialState);
  };

  const handleAddAction = (type) => {
    let actionsList = getPath(initialState, "actionsList", {});
    (actionsList[type] = actionsList[type] ? actionsList[type] : []).push("");
    setInitialState({ ...initialState, actionsList: actionsList });
  };

  const handleDeleteAction = (type, index) => {
    const values = { ...initialState };
    const actionsList = getPath(values, "actionsList", {});
    actionsList[type].splice(index, 1);

    setInitialState({
      ...values,
      actionsList: actionsList,
    });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    if (key === "entity") {
      values["entityId"] = "";
      values["activeCityId"] = "";
      setPriorityFlag(true);
    } else if (key === "entityId") {
      values[key] = val + "";
      setPriorityFlag(false);
    } else if (key === "dataType") {
      delete values["value"];
    } else if (key === "value") {
      if (!initialState.dataType) {
        props.setStatus({ type: "error", message: "data type is required" });
        return;
      }
      if (initialState.dataType == "json") {
        try {
          console.log(val);
          JSON.parse(val);
          setIsValidJson(true);
        } catch (error) {
          console.log(error);
          setIsValidJson(false);
        }
      }
    }
    setInitialState(values);
  };

  const setActiveCity = (value) => {
    let values = { ...initialState };
    values["entityId"] = "";
    values["activeCityId"] = value;
    setInitialState(values);
  };

  const getDataValue = () => {
    if (initialState.dataType == "bool") {
      return (
        <PaginatedReactDropdown
          options={boolValueOptions}
          data-testid="featureConfigentity"
          labelKey="label"
          valueKey="key"
          labelWidth="16%"
          value={getInputLabel(
            initialState.value,
            boolValueOptions,
            "key",
            "label"
          )}
          handleChange={handleChange}
          keyToChange="value"
          placeholder="Value"
          showCross={false}
          id="featureConfigentityDropdown"
        />
      );
    } else if (initialState.dataType == "time") {
      return (
        <>
          <p>Please enter unix timestamp (in seconds)</p>
          <Input
            value={initialState.value}
            onChange={(e) => handleChange("value", e)}
            placeholder="Value"
            data-testid="key"
            id="sushi-input"
            label="Value"
            style={{ marginTop: "10px" }}
          />
        </>
      );
    } else if (initialState.dataType == "json") {
      return (
        <>
          <AceEditor
            mode="json"
            theme="monokai"
            value={
              isJson(initialState.value)
                ? beautify.js(initialState.value, { indent_size: 2 })
                : initialState.value
            }
            onChange={(e) => handleChange("value", e)}
            name="json-editor"
            editorProps={{ $blockScrolling: true }}
            style={{ width: "100%", height: "300px", marginBottom: "20px" }}
          />
          {!isValidJson && <p style={{ color: "red" }}>Invalid JSON</p>}
        </>
      );
    }

    return (
      <Input
        value={initialState.value}
        onChange={(e) => handleChange("value", e)}
        placeholder="Value"
        data-testid="key"
        id="sushi-input"
        label="Value"
      />
    );
  };

  const getVariantValue = (variant, variantIndex) => {
    if (initialState.dataType == "bool") {
      return (
        <PaginatedReactDropdown
          options={boolValueOptions}
          data-testid="featureConfigentity"
          labelKey="label"
          valueKey="key"
          labelWidth="16%"
          value={getBoolInputLabel(variant.value, boolValueOptions, "key", "label")}
          handleChange={(key,val) => handleVariantListChange("value", val, [variantIndex])}
          keyToChange="value"
          placeholder="Value"
          showCross={false}
          id="featureConfigentityDropdown"
        />
      );
    } else if (initialState.dataType == "time") {
      return (
        <>
          <p>Please enter unix timestamp (in seconds)</p>
          <Input
            value={variant.value}
            onChange={(e) =>
              handleVariantListChange("value", e, [variantIndex])
            }
            placeholder="Value"
            data-testid="key"
            id="sushi-input"
            label="Value"
            style={{ marginTop: "10px" }}
          />
        </>
      );
    } else if (initialState.dataType == "json") {
      let val =
        typeof variant.value == "object"
          ? JSON.stringify(variant.value)
          : variant.value;

      return (
        <>
          <AceEditor
            mode="json"
            theme="monokai"
            value={isJson(val) ? beautify.js(val) : val}
            onChange={(e) =>
              handleVariantListChange("value", e, [variantIndex])
            }
            name="json-editor"
            editorProps={{ $blockScrolling: true }}
            style={{ width: "100%", height: "300px", marginBottom: "20px" }}
          />
          {!isValidJson && <p style={{ color: "red" }}>Invalid JSON</p>}
        </>
      );
    }

    return (
      <Input
        value={variant.value}
        onChange={(e) => handleVariantListChange("value", e, [variantIndex])}
        placeholder="Value"
        data-testid="key"
        id="sushi-input"
        label="Value"
      />
    );
  };

  const getentityIdFields = () => {
    switch (initialState.entity) {
      case "User":
        return (
          <React.Fragment>
            <Input
              value={initialState.entityId}
              data-testid="updatedAt"
              id="sushi-input"
              onChange={(e) => handleChange("entityId", e)}
              disabled={checkIfDisabled("entityId")}
              label={"User ID"}
            />
          </React.Fragment>
        );
      case "Country":
        return (
          <InfiniteScrollDropdown
            priorityFlag={true}
            id="countryDropdown"
            appliedFilters={{}}
            getActiveList={getCountryList}
            nextPage={nextPageCountry}
            resKey="countries"
            modalState={modalState}
            keyName="entityId"
            labelKey="country_name"
            getDataLabelKey="country.country_name"
            keyTypeToSet="id"
            disabled={checkIfDisabled("entityId")}
            label="Country"
            handleChange={handleChange}
            remoteSearchApplicable={false}
            activeFilters={{
              entity: initialState.entity,
              entityId: initialState.entityId,
            }}
            getActiveItemById={getCountry}
          />
        );
      case "City":
        return (
          <InfiniteScrollDropdown
            id="cityDropdown"
            priorityFlag={true}
            appliedFilters={{}}
            getActiveList={getCityList}
            nextPage={nextPageCity}
            resKey="cities"
            modalState={modalState}
            keyName="entityId"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            disabled={checkIfDisabled("entityId")}
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            value={initialState.activeCityId}
            activeFilters={{
              entity: initialState.entity,
              entityId: initialState.entityId,
            }}
            getActiveItemById={getCity}
          />
        );
      case "Locality":
        return (
          <React.Fragment>
            <InfiniteScrollDropdown
              id="activeCityDropdown"
              priorityFlag={true}
              appliedFilters={{}}
              getActiveList={getCityList}
              nextPage={nextPageCity}
              resKey="cities"
              modalState={modalState}
              keyName="activeCityId"
              stateDependent={true}
              labelKey="city_name"
              getDataLabelKey="city.city_name"
              keyTypeToSet="id"
              getActiveItemById={props.getCity}
              disabled={checkIfDisabled("activeCityId")}
              label="City"
              handleChange={setActiveCity}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeFilters={{
                entity: initialState.entity,
                entityId: initialState.entityId,
                activeCityId: initialState.activeCityId,
              }}
            />
            <InfiniteScrollDropdown
              id="activeLocalityDropdown"
              priorityFlag={true}
              appliedFilters={
                initialState.activeCityId
                  ? { city_id: initialState.activeCityId }
                  : {}
              }
              appliedFilterValue={initialState.activeCityId}
              getActiveList={getLocalityList}
              nextPage={props.nextPageLocality}
              resKey="localities"
              modalState={modalState}
              keyName="entityId"
              labelKey="locality_name"
              labels={["locality_name", "id"]}
              getDataLabelKey="locality.locality_name"
              keyTypeToSet="id"
              getActiveItemById={props.getLocality}
              disabled={checkIfDisabled("entityId")}
              label="Locality"
              handleChange={handleChange}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeFilters={{
                entity: initialState.entity,
                entityId: initialState.entityId,
              }}
            />
          </React.Fragment>
        );
      default:
        return "";
    }
  };

  const checkIfDisabled = (key) => {
    return modalState === "Edit"
      ? disabledFieldsInEditState.includes(key)
        ? true
        : false
      : false;
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };
  const getBoolInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => {
        return item[fromKey] ==  `${val}` || item[fromKey] == val }
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const getDataType = (data) => {
    switch (typeof data) {
      case "boolean":
        return "bool";
      case "number":
        return "float64";
      case "object":
        return "json";
      default:
        return "string";
    }
  };

  const getData = (data) => {
    switch (typeof data) {
      case "object":
        return JSON.stringify(data);
      default:
        return String(data);
    }
  };

  const syncFilters = () => {
    const values = { ...initialState };
    values["key"] = selectedKey;
    values["namespace"] = selectedNamespace;
    values["entity"] = selectedEntity;
    values["entityId"] = selectedEntityId;

    const page = 1;
    const payload = {
      filters: {
        key: selectedKey,
        hierarchy: {
          entity: selectedEntity,
          entityId: selectedEntityId,
        },
      },
      namespace: selectedNamespace,
      pagination: {
        limit: 20,
      },
    };
    props.filterKeyConfigs(payload).then((res) => {
      // namespace actions required
      let readActionsRequired = _.cloneDeep(getPath(res, "actions.read", []));
      let writeActionsRequired = _.cloneDeep(getPath(res, "actions.write", []));

      let keyConfigs = getPath(res, "keyConfigs", []);
      if (keyConfigs.length > 0) {
        values["variantsList"] = getPath(keyConfigs[0], "variants", []);
        const value = getPath(keyConfigs[0], "value", "");
        values["dataType"] = getDataType(value);
        values["value"] = getData(value);
        values["actionsList"] = getPath(keyConfigs[0], "actions", {});
        values["rulesList"] = getPath(keyConfigs[0], "rules", []);

        // config actions required
        readActionsRequired.push(...getPath(keyConfigs[0], "actions.read", []));
        writeActionsRequired.push(
          ...getPath(keyConfigs[0], "actions.write", [])
        );
      }

      values["actionsRequired"]["read"] = readActionsRequired;
      values["actionsRequired"]["write"] = writeActionsRequired;
      setInitialState(values);
    });
  };

  useEffect(() => {
    if (modalState === "Edit") {
      syncFilters();
    }
  }, [modalState]);

  useEffect(() => {
    if (
      Object.keys(activeHierarchyFiltersConfig).length > 0 &&
      modalState === "Filter"
    ) {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeHierarchyFiltersConfig[key]
          ? activeHierarchyFiltersConfig[key]
          : "";
      });
      values["serviceId"] = [];
      setPriorityFlag(1);
      setInitialState(values);
    }
  }, [activeHierarchyFiltersConfig]);

  const isAddOrEdit = (modalState) =>
    modalState === "Add" || modalState === "Edit";

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState === "Add" ? "Create" : modalState} Feature Config`}
      handleClose={handleClose}
      id="FeatureConfigFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="filterFeatureBtn"
              onClick={handleClearFilters}
              btnColor="coal"
              appearance="solid"
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          {modalState === "Filter" && (
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              btnColor="coal"
              appearance="solid"
              onClick={applyFilter}
            >
              Apply
            </Button>
          )}
          {isAddOrEdit(modalState) && (
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              btnColor="coal"
              appearance="solid"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          )}
        </BottomSectionModal>
      }
    >
      {isAddOrEdit(modalState) && (
        <Input
          value={initialState.key}
          data-testid="key"
          id="sushi-input"
          label="Key"
          disabled={modalState === "Edit"}
          onChange={(e) => handleChange("key", e)}
        />
      )}
      <PaginatedReactDropdown
        options={entityOptions}
        data-testid="featureconfigentity"
        labelKey="label"
        valueKey="key"
        labelWidth="16%"
        disabled={checkIfDisabled("entity")}
        value={getInputLabel(
          initialState.entity,
          entityOptions,
          "key",
          "label"
        )}
        handleChange={handleChange}
        keyToChange="entity"
        placeholder="Entity"
        showCross={false}
        id="featureConfigentityDropdown"
      />
      {initialState.entity && getentityIdFields()}

      {isAddOrEdit(modalState) && (
        <section style={{ marginTop: "30px" }}>
          <PaginatedReactDropdown
            options={DataTypeOptions}
            data-testid="featureconfigentity"
            labelKey="label"
            valueKey="key"
            labelWidth="16%"
            value={getInputLabel(
              initialState.dataType,
              DataTypeOptions,
              "key",
              "label"
            )}
            handleChange={handleChange}
            keyToChange="dataType"
            placeholder="Data Type"
            showCross={false}
            id="featureconfigentityDropdown"
          />

          {getDataValue()}

          <VariantSection>
          {selectedEntity === "" && modalState === "Edit" && (
        <div className="mt-30" justify="flex-start">
          <Checkbox
            value="stable"
            color={variables.black}
            checked={initialState.stable}
            onChange={(e) => handleChange("stable", e.stable)}
            className="sushi-checkbox mr-30 mb-30"
            label={"Stable (This will override existing hierarchy configs)"}
          />
        </div>
          )}
        </VariantSection>

          {initialState.variantsList.map((variant, variantIndex) => {
            return (
              <VariantSection>
                <div className="flex items-center justify-between">
                  <p className="sectionHeading">Variant {variantIndex + 1}</p>
                  <Cross
                    size={20}
                    showPointer={true}
                    onClick={() => handleDeleteVariant(variantIndex)}
                  />
                </div>
                {variant.conditions.map((detailCondition, index) => {
                  return (
                    <Conditionsection>
                      <div className="flex items-center justify-between">
                        <p className="sectionHeading">Condition {index + 1}</p>
                        <Cross
                          size={20}
                          showPointer={true}
                          onClick={() =>
                            handleDeleteCondition(variantIndex, index)
                          }
                        />
                      </div>
                      {detailCondition.lhs == "" ? (
                        <PaginatedReactDropdown
                          options={conditionTypeOptions}
                          data-testid={`featureConditionOption${index}`}
                          labelKey="label"
                          valueKey="key"
                          labelWidth="17%"
                          value={getInputLabel(
                            detailCondition.lhs,
                            conditionTypeOptions,
                            "key",
                            "label",
                            false
                          )}
                          extraParamsOptionDisable={[variantIndex, index]}
                          handleChange={handleVariantListChange}
                          keyToChange="lhs"
                          extraParams={[variantIndex, index]}
                          placeholder="Condition Type"
                          showCross={false}
                          id={`featureConditionOption${index}`}
                        />
                      ) : detailCondition.lhs != "custom" ? (
                        <Input
                          value={detailCondition.lhs}
                          data-testid={`featureConditionValue${index}`}
                          id="sushi-input"
                          onChange={(e) =>
                            handleVariantListChange("customCondition", e, [
                              variantIndex,
                              index,
                            ])
                          }
                          label={"Condition Name"}
                        />
                      ) : (
                        <></>
                      )}

                      {detailCondition.lhs == "custom" && (
                        <Input
                          value={detailCondition.customCondition}
                          data-testid={`featureConditionValue${index}`}
                          id="sushi-input"
                          onChange={(e) =>
                            handleVariantListChange("customCondition", e, [
                              variantIndex,
                              index,
                            ])
                          }
                          label={"Condition Name"}
                        />
                      )}
                      <PaginatedReactDropdown
                        options={comparatorOptions}
                        data-testid={`featureComparatorOption${index}`}
                        labelKey="label"
                        valueKey="key"
                        labelWidth="14%"
                        value={getInputLabel(
                          detailCondition.op,
                          comparatorOptions,
                          "key",
                          "label",
                          false
                        )}
                        handleChange={handleVariantListChange}
                        keyToChange="op"
                        extraParams={[variantIndex, index]}
                        isOptionDisabled={(option) => {
                          switch (
                            initialState.variantsList[variantIndex].conditions[
                              index
                            ].lhs
                          ) {
                            case "app_version":
                              return option == "In" || option == "Not in";
                            case "service_id":
                              return option != "In" && option != "Not in";
                            case "source_id":
                              return option != "In" && option != "Not in";
                            default:
                              return false;
                          }
                        }}
                        placeholder="Operator"
                        showCross={false}
                        id={`featureComparatorOption${index}`}
                      />

                      {detailCondition.lhs == "timestamp" ? (
                        <p style={{ marginBottom: "10px" }}>
                          Unix timestamp in seconds
                        </p>
                      ) : (
                        <></>
                      )}

                      {detailCondition.lhs == "service_id" ? (
                        <InfiniteScrollDropdown
                          id={`driverServicesDropdown${index}`}
                          priorityFlag={true}
                          activeElement={detailCondition}
                          getActiveList={getDriverServices}
                          resKey="driver_services"
                          modalState={dropDownModalState}
                          keyName="rhs"
                          labelKey="name"
                          getDataLabelKey="driver_services.name"
                          keyTypeToSet="id"
                          label="Delivery Services"
                          handleChange={handleVariantListChange}
                          extraParams={[variantIndex, index]}
                          getActiveItemById={getDriverServiceByIds}
                          multiple
                        />
                      ) : (
                        <Input
                          value={
                            Array.isArray(detailCondition.rhs)
                              ? JSON.stringify(detailCondition.rhs)
                              : detailCondition.rhs
                          }
                          data-testid={`featureConditionValue${index}`}
                          id="sushi-input"
                          onChange={(e) =>
                            handleVariantListChange("rhs", e, [
                              variantIndex,
                              index,
                            ])
                          }
                          label={getInputLabel(
                            detailCondition.lhs,
                            conditionTypeOptions,
                            "key",
                            "label",
                            false
                          )}
                        />
                      )}
                    </Conditionsection>
                  );
                })}
                <AddConditionContainer justify={"flex-end"}>
                  <div
                    className="flex delete-icon"
                    onClick={() => {
                      handleAddCondition(variantIndex);
                    }}
                  >
                    <PlusCircle color={variables.black} size={20} />
                    <span>
                      Add {variant.conditions.length ? "another" : ""} condition
                    </span>
                  </div>
                </AddConditionContainer>
                <p className="sectionHeading">Value</p>

                {getVariantValue(variant, variantIndex)}
              </VariantSection>
            );
          })}

          <AddVariantContainer>
            <div
              className="flex delete-icon"
              onClick={() => {
                handleAddVariant();
              }}
            >
              <PlusCircle color={variables.black} size={20} />
              <span>
                Add {initialState.variantsList.length ? "another" : ""} variant
              </span>
            </div>
          </AddVariantContainer>

          {initialState.rulesList.map((rule, index) => {
            return (
              <RuleSection>
                <div className="flex items-center justify-between">
                  <p className="sectionHeading">Rule {index + 1}</p>
                  <Cross
                    size={20}
                    showPointer={true}
                    onClick={() => handleDeleteRule(index)}
                  />
                </div>
                <PaginatedReactDropdown
                  options={ruleTypeOptions}
                  data-testid={`featureConditionOption${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="17%"
                  value={getInputLabel(
                    rule.type,
                    ruleTypeOptions,
                    "key",
                    "label",
                    false
                  )}
                  extraParamsOptionDisable={[index]}
                  handleChange={handleRuleListChange}
                  keyToChange="type"
                  extraParams={[index]}
                  placeholder="Rule Type"
                  showCross={false}
                  id={`featureConditionOption${index}`}
                />
                <PaginatedReactDropdown
                  options={ruleSubTypeOptions}
                  data-testid={`featureComparatorOption${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="14%"
                  value={getInputLabel(
                    rule.subType,
                    ruleSubTypeOptions,
                    "key",
                    "label",
                    false
                  )}
                  handleChange={handleRuleListChange}
                  keyToChange="subType"
                  extraParams={[index]}
                  isOptionDisabled={(option) => {
                    switch (initialState.rulesList[index].type) {
                      case "pre-update":
                        return POST_UPDATE_SUB_TYPE_LABELS.includes(option);
                      case "post-update":
                        return PRE_UPDATE_SUB_TYPE_LABELS.includes(option);
                      default:
                        return false;
                    }
                  }}
                  placeholder="Sub Type"
                  showCross={false}
                  id={`featureComparatorOption${index}`}
                />
                {rule.subType == RULE_SUB_TYPES.PEAK_TIME && (
                  <div>
                    <DateTimePicker
                      value={rule.baseRule?.StartTime}
                      placeholder="Start Time"
                      handleChange={(e) =>
                        handleRuleListChange("StartTime", e.target.value, [
                          index,
                        ])
                      }
                      id="start_time"
                    />
                    <DateTimePicker
                      value={rule.baseRule?.EndTime}
                      placeholder="End Time"
                      handleChange={(e) =>
                        handleRuleListChange("EndTime", e.target.value, [index])
                      }
                      id="end_time"
                    />

                    <PaginatedReactDropdown
                      options={REPEAT_OPTIONS}
                      data-testid={`repeatOptions${index}`}
                      labelKey="label"
                      valueKey="key"
                      labelWidth="17%"
                      value={getInputLabel(
                        rule.baseRule.Repeat,
                        REPEAT_OPTIONS,
                        "key",
                        "label",
                        false
                      )}
                      extraParamsOptionDisable={[index]}
                      handleChange={handleRuleListChange}
                      keyToChange="Repeat"
                      extraParams={[index]}
                      placeholder="Repeat"
                      showCross={false}
                      id={`repeatOptions${index}`}
                    />
                  </div>
                )}

                {rule.subType == "notification" && (
                  <div>
                    <p className="sectionHeading">Rule Configuration</p>
                    <PaginatedReactDropdown
                      options={notificationOptions}
                      data-testid={`featureConditionOption${index}`}
                      labelKey="label"
                      valueKey="key"
                      labelWidth="17%"
                      value={getInputLabel(
                        rule.baseRule.Source,
                        notificationOptions,
                        "key",
                        "label",
                        false
                      )}
                      extraParamsOptionDisable={[index]}
                      handleChange={handleRuleListChange}
                      keyToChange="Source"
                      extraParams={[index]}
                      placeholder="Source"
                      showCross={false}
                      id={`featureConditionOption${index}`}
                    />

                    <p style={{ marginBottom: "20px" }}>
                      Provide slack channel name where you want config updates
                      to be delivered. You can specify slack channel on
                      key/namespace level. Please make sure #config-update-alert
                      bot is added into that channel.
                    </p>

                    <Input
                      value={rule.baseRule?.Meta?.Channel}
                      data-testid={`featureConditionValue${index}`}
                      id="sushi-input"
                      onChange={(e) =>
                        handleRuleListChange("Channel", e, [index])
                      }
                      label={"Channel Name"}
                    />
                  </div>
                )}

                {rule.subType == "validation" && (
                  <div>
                    <p className="sectionHeading">Rule Configuration</p>
                    <p style={{ marginBottom: "20px" }}>
                      Schema should be defined on global configuration. This
                      ensures properties are created as expected. Please refer
                      to JSON Schema draft for how to write validation schema.
                      Supports draft-04, draft-06, and draft-07. References:
                    </p>
                    <ul style={{ marginBottom: "20px" }}>
                      <li>
                        <a
                          href="https://json-schema.org/learn/getting-started-step-by-step"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://json-schema.org/learn/getting-started-step-by-step
                        </a>
                      </li>
                    </ul>

                    <AceEditor
                      mode="json"
                      theme="monokai"
                      label={"Validation Schema"}
                      value={rule.baseRule?.Schema}
                      onChange={(e) =>
                        handleRuleListChange("Schema", e, [index])
                      }
                      name="json-editor"
                      editorProps={{ $blockScrolling: true }}
                      style={{
                        width: "100%",
                        height: "300px",
                        marginBottom: "20px",
                      }}
                    />
                    {!isValidJsonSchema && (
                      <p style={{ color: "red" }}>Invalid JSON Schema</p>
                    )}
                  </div>
                )}
              </RuleSection>
            );
          })}

          <AddRuleContainer>
            <div
              className="flex delete-icon"
              onClick={() => {
                handleAddRule();
              }}
            >
              <PlusCircle color={variables.black} size={20} />
              <span>
                Add {initialState.rulesList.length ? "another" : ""} Rule (e.g.
                config validation / notification etc)
              </span>
            </div>
          </AddRuleContainer>

          {getPath(initialState, "actionsList.read", []).map(
            (readAction, index) => {
              return (
                <ActionSection>
                  <div className="flex items-center justify-between">
                    <p className="sectionHeading">Read Action {index + 1}</p>
                    <Cross
                      size={20}
                      showPointer={true}
                      onClick={() => handleDeleteAction("read", index)}
                    />
                  </div>
                  <Input
                    value={readAction}
                    data-testid="read-action"
                    id="sushi-input"
                    label="Read Action"
                    onChange={(e) => handleActionChange("read", e, index)}
                  />
                </ActionSection>
              );
            }
          )}
          <AddActionContainer>
            <div
              className="flex delete-icon"
              onClick={() => {
                handleAddAction("read");
              }}
            >
              <PlusCircle color={variables.black} size={20} />
              <span>
                Add
                {getPath(initialState, "actionsList.read", []).length
                  ? " Another"
                  : ""}{" "}
                Read Action
              </span>
            </div>
          </AddActionContainer>

          {getPath(initialState, "actionsList.write", []).map(
            (writeAction, index) => {
              return (
                <ActionSection>
                  <div className="flex items-center justify-between">
                    <p className="sectionHeading">Write Action {index + 1}</p>
                    <Cross
                      size={20}
                      showPointer={true}
                      onClick={() => handleDeleteAction("write", index)}
                    />
                  </div>
                  <Input
                    value={writeAction}
                    data-testid="write-action"
                    id="sushi-input"
                    label="write Action"
                    onChange={(e) => handleActionChange("write", e, index)}
                  />
                </ActionSection>
              );
            }
          )}
          <AddActionContainer>
            <div
              className="flex delete-icon"
              onClick={() => {
                handleAddAction("write");
              }}
            >
              <PlusCircle color={variables.black} size={20} />
              <span>
                Add
                {getPath(initialState, "actionsList.write", []).length
                  ? " Another "
                  : " "}
                Write Action
              </span>
            </div>
          </AddActionContainer>
        </section>
      )}
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { FeatureConfig, Country, City, Locality, Feature } = state;
  return {
    activeHierarchyFiltersConfig: FeatureConfig.activeHierarchyFiltersConfig,
    countryList: Country.countryList,
    cityList: City.cityList,
    localityList: Locality.localityList,
    featureList: Feature.featureList,
    nextPageCountry: Country.nextPage,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    allLocalityList: Locality.allLocalityList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    filterKeyConfigs: bindActionCreators(
      FeatureConfigActions.filterKeyConfigs,
      dispatch
    ),
    upsertConfig: bindActionCreators(
      FeatureConfigActions.upsertConfig,
      dispatch
    ),
    getNamespace: bindActionCreators(
      FeatureConfigActions.getNamespace,
      dispatch
    ),
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    resetState: bindActionCreators(FeatureActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getCountry: bindActionCreators(CountryActions.getCountry, dispatch),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getDriverServices: bindActionCreators(
      DriverServicesActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverServicesActions.getDriverServiceByIds,
      dispatch
    ),
    resetStateFeatureConfig: bindActionCreators(
      FeatureConfigActions.resetStateFeatureConfig,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureConfigFormModal);

const AddConditionContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const AddVariantContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const Conditionsection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const VariantSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const RuleSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const ActionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.75rem;
    margin-top: 1rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const AddRuleContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const AddActionContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;
